import { useMutation, useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy, parseError, useLoggedInAuthContext, useToast } from 'common';

interface UseAgentApiProps {
  agentId?: string | null;
}

export function useAgentApi(props: UseAgentApiProps) {
  const { agentId } = props;
  const toast = useToast();
  const { checkAgentPermissions } = useLoggedInAuthContext();

  const agentResponse = useQuery({
    ...getQueryProps(api.client.FlowAgent, 'findOneById', agentId || 'INVALID_ID'),
    enabled: isTruthy(agentId),
  });
  const updateAgentMutation = useMutation({
    mutationFn: async (agentAndId: { id: string } & Partial<api.FlowAgent.Agent>) => {
      const { id, ...agentProps } = agentAndId;
      return await api.client.FlowAgent.update(id, agentProps);
    },
    onSuccess: async () => {
      await agentResponse.refetch();
    },
    onError: (error) => {
      toast.showError(parseError(error, 'Failed to update agent'));
    },
  });

  const agentPermissions = checkAgentPermissions({
    agentId: agentId ?? undefined,
    organizationId: agentResponse.data?.organizationId,
  });

  return {
    agentResponse,
    updateAgentMutation,
    agentPermissions,
  };
}
